import { useEffect, useState } from 'react';
import {
    Paper, Typography, Table, TableHead, TableRow, TableCell, TableBody, Chip, Skeleton, Stack, Box, Button,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import api from '../utils/axios';
import { formatPrice, formatDate, orderStatusLabel } from '../utils/format';
import { b2bColors } from '../styles/b2bTheme';
import { getErrorMessage, buildErrorSnackbarOptions } from '../utils/errorUtils';

export default function Orders() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [orders, setOrders] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get('/b2b/orders', { params: { limit: 50 } });
                if (cancelled) return;
                setOrders(data.orders || []);
            } catch (err) {
                if (cancelled) return;
                enqueueSnackbar(getErrorMessage(err, 'Chargement impossible'), buildErrorSnackbarOptions(err, closeSnackbar));
                setOrders([]);
            }
        })();
        return () => { cancelled = true; };
    }, [enqueueSnackbar, closeSnackbar]);

    return (
        <Stack spacing={3}>
            <Typography variant="h1">Mes commandes</Typography>

            {orders === null ? (
                <Paper sx={{ p: 2 }}>
                    <Stack spacing={1}>
                        {Array.from({ length: 5 }).map((_, i) => <Skeleton key={i} height={48} variant="rectangular" />)}
                    </Stack>
                </Paper>
            ) : orders.length === 0 ? (
                <Paper sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body1">Aucune commande pour l'instant.</Typography>
                    <Button component={RouterLink} to="/catalogue" sx={{ mt: 2 }} variant="contained">
                        Parcourir le catalogue
                    </Button>
                </Paper>
            ) : (
                <Paper>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>N°</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Lignes</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell align="right" className="b2b-num">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {orders.map((o) => (
                                <TableRow key={o.id} hover>
                                    <TableCell>
                                        <Box
                                            component={RouterLink}
                                            to={`/orders/${o.id}`}
                                            sx={{ color: b2bColors.primary, textDecoration: 'none', fontWeight: 600 }}
                                        >
                                            {o.order_number}
                                        </Box>
                                    </TableCell>
                                    <TableCell className="b2b-num">{formatDate(o.order_date)}</TableCell>
                                    <TableCell className="b2b-num">{o.line_count}</TableCell>
                                    <TableCell><Chip size="small" label={orderStatusLabel(o.status)} /></TableCell>
                                    <TableCell align="right" className="b2b-num" sx={{ fontWeight: 600 }}>
                                        {formatPrice(o.total)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            )}
        </Stack>
    );
}
